/** Header action buttons (Add to, Annotate, Comment): secondary label, no hover tint. */
export const headerActionClassName =
  "gap-1.5 text-foreground-secondary hover:bg-accent hover:text-foreground-secondary";
